import type { HTMLAttributes } from "react";
import { cx } from "./cx";
import { CHANNEL_STATE, MESSAGE_STATE, type ChannelState, type MessageState, type Tone } from "./state";

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  /** 去掉前面的圆点，用于非状态类标签。 */
  plain?: boolean;
}

export function Pill({ tone = "neutral", plain, className, ...rest }: PillProps) {
  return <span className={cx("ax-pill", tone !== "neutral" && `ax-pill-${tone}`, plain && "ax-pill-plain", className)} {...rest} />;
}

export function MessageStatePill({ state }: { state: MessageState }) {
  const m = MESSAGE_STATE[state] ?? { tone: "neutral", label: state };
  return <Pill tone={m.tone} data-state={state}>{m.label}</Pill>;
}

export function ChannelStatePill({ state }: { state: ChannelState }) {
  const m = CHANNEL_STATE[state] ?? { tone: "neutral", label: state };
  return <Pill tone={m.tone} data-state={state}>{m.label}</Pill>;
}
